import { Class } from './utils'
import icons from './resources/icons'
import Result from './Result'

/**
 * 
 * @class QueryResult
 * @classdesc A collection of {@link Result}s The result from a fetchData call to a searcher. Only Searchers will create instances
 * 
 */
export default Class (
  {
	
    _searcher: null,
    _results: null,
    _newQueries: null,
    _suggestions: null,
    _allResults: null,
	
    initialize: function (searcher) {
      this._searcher = searcher;
      this._results = [];
      this._newQueries = [];
      this._suggestions = [];
      this._allResults = [];
      this._target = this.getTarget(this._searcher);
      if (searcher && searcher.hasOwnProperty("iconURI") && searcher.iconURI !== null && searcher.iconURI !== "" && searcher.iconURI !== undefined){
        this.newQueryIconURI = searcher.iconURI;
        this.resultIconURI = searcher.iconURI;
      }else{
        this.newQueryIconURI = icons.result.defaultNewQueryIcon;
        this.resultIconURI = icons.result.defaultIcon;
      }

    },
	
    addResult: function(source, type, title, description, geometry, data){
      let result = new Result({
        source,
        type,
        title,
        description,
        geometry,
        data,
        "searcher": this._searcher,
        "image": this.resultIconURI
      });
      /*
      const result = {
        source,
        type,
        title,
        description,
        geometry,
        data,
        "searcher": this._searcher,
        "image": this.resultIconURI
      };
      */
      this._results.push(result);
      this._allResults.push(result);
      return result;
    },
	
    addResults: function(results){
      for (let i=0; i<results.length; i++){
        let result = results[i];
        if (typeof result.target === 'undefined'){
          result.target = this._target;
        }
        this._results.push(result);
        this._allResults.push(result);
      }
    },
	
    addSuggestion: function(source, type, querystring){
      this._suggestions.push(
        {   source,
          type,
          querystring,
          "searcher": this._searcher});
    },
	
    addSuggestions: function(suggestions){
      for (let i=0; i<suggestions.length; i++){
        this._suggestions.push(suggestions[i]);
      }
    },
	
    addNewQuery: function(source, type, title, description, newQuery, geometry, data){
      let newNewQuery = new Result({
        source,
        type,
        title,
        description,
        "newquery": newQuery,
        geometry,
        data,
        "searcher": this._searcher,
        "image": this.newQueryIconURI
      });
      /*
      const newNewQuery = {
        source,
        type,
        title,
        description,
        "newquery": newQuery,
        geometry,
        data,
        "searcher": this._searcher,
        "image": this.newQueryIconURI
      };
      */
      this._newQueries.push(newNewQuery);
      this._allResults.push(newNewQuery);
      return newNewQuery;
    },
	
    addNewQueries: function(newQueries){
      for (let i=0; i<newQueries.length; i++){
        this._newQueries.push(newQueries[i]);
        this._allResults.push(newQueries[i]);
      }
    },
	
    getSearcher: function(){
      return this._searcher;
    },
	
    getTarget: function(searcher){
      let target = "none";
      if (typeof searcher !== 'undefined' && searcher !== null){
        if (searcher.title !== ''){
          target = searcher.title;
        }else{
          target = searcher.getId();
        }
      }
      return target;
    },
	
    getNewQueries: function(){
      return this._newQueries;
    },
	
    getResults: function(){
      return this._results;
    },
	
    getAllResults: function(){
      return this._allResults;
    },
	
    getSuggestions: function(){
      return this._suggestions;
    },
	
    CLASS_NAME: 'Septima.Search.QueryResult'

  });
